export var isModifier = function isModifier(key) {
  return key[0] === '&';
};
export var isElement = function isElement(key) {
  return !isModifier(key);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/substyle/es6/filterKeys.js
// module id = 143
// module chunks = 0